import { Color as l, Float32BufferAttribute as n } from "three";
const o = new l();
function u(t, r, e) {
  o.set(r);
  const c = t.getAttribute("position").count, i = Array(c).fill([...o.toArray(), e]).flat();
  t.setAttribute("color", new n(i, 4));
}
export {
  u as setColor
};
//# sourceMappingURL=index5.js.map
